export enum FeatureFlag {
    TokenEventLogging = 'config-ui-enable-token-event-logging',
    ShowNewIngestConfigurationFields = 'Config-Show-New-Ingest-Configuration-Fields',
    UseModifiedDBXLink = 'Config-Use-Modified-DBX-Link',
    ShowAdminTenantSSOSelfServiceTab = 'Config-Show-Admin-Tenant-SSO-Self-Service-Tab',
    EnableIncrementalCdcRawMode = 'Config-Enable-Incremental-CDC-Raw-Mode',
    DatamartPromotionHistory = 'Config-DatamartPromotionHistory',
    ApplicationImportExport = 'Idea-Enable-Application-Import-Export'
}

export const FeatureFlagDetails = {
    'config-ui-enable-token-event-logging': {
        name: 'Okta Service Token Manager Logging',
        description: ''
    }
};
